import {Component, HostListener, OnInit, ViewChild, AfterContentChecked, ChangeDetectorRef} from '@angular/core';
import {AlertService} from '../../services/alert/alert.service';
import {ReportsService} from '../../services/reports/reports.service';
// import { Observable } from 'rxjs/Observable';
import {LoadingService} from '../../services/loading/loading.service';
// import * as FileSaver from 'file-saver';
// import { DownloadFileResponse } from '../../shared/common-components/file-storage/downloadFileResponse';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import _ from 'lodash';
import {HHGSummaryListFilter} from './hhg-summary-list-filter';
import moment from 'moment';


@Component({
    selector: 'app-hhg-summary-list',
    templateUrl: './hhg-summary-list.component.html',
    styleUrls: ['./hhg-summary-list.component.css'],
    standalone: false
})


export class HhgSummaryListComponent implements OnInit {
  public errorMessage = '';
  filterGroup: UntypedFormGroup;
  order = 'hhg';
  reverse = false;
  // may need to improve searching results
  hhg_filter: HHGSummaryListFilter = {
    beginDate: 0,
    endDate: Date.now()
  };
  private gridApi;
  strloader;
  paginationPageSize;
  domLayout;
  hhgListDetails = [
    {}
  ];
  hhgListColumnDefs = [
    {
      headerName: 'Agency Name',
      field: 'agencyName',
      filter: 'agTextColumnFilter',
      sortable: true,
      resizable: true
    },
    {
      headerName: 'Bureau Name',
      field: 'bureauName',
      filter: 'agTextColumnFilter',
      sortable: true,
      resizable: true,
    },
    /*
    {
      headerName: 'Bureau Creation Date',
      field: 'bureauCreationDate',
      filter: 'agTextColumnFilter',
      sortable: true,
      resizable: true,
      valueGetter: function (params) {
        return moment(params.data.bureauCreationDate).format('MM/DD/YYYY');
      }
    },
    */
    {
      headerName: 'Auth Official Name (AO)',
      field: 'Roname',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueGetter: function (params) {
        return params.data.roLastName + ',' + params.data.roFirstName;
      }
    },
    {
      headerName: 'AO Location',
      field: 'roLocation',
      filter: 'agTextColumnFilter',
      sortable: true,
      type: 'leftaligned',
      width: 150,
      valueGetter: function (params) {
        return params.data.roCity + ',' + params.data.roStateCode;
      }
    },
    /*
    {
      headerName: 'RO Creation Date',
      field: 'roCreationDate',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueGetter: function (params) {
        return moment(params.data.roCreationDate).format('MM/DD/YYYY');
      }
    },
    */
    {
      headerName: 'User Name',
      field: 'userName',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueGetter: function (params) {
        return params.data.userLastName + ',' + params.data.userFirstName;
      }
    }, //userFaicCode
    {headerName: 'User FAIC Code', field: 'userFaicCode', filter: 'agTextColumnFilter', sortable: true, width: 140,resizable: true},
    {headerName: 'User Email', field: 'userContactEmail', filter: 'agTextColumnFilter', sortable: true, resizable: true},
    {headerName: 'User Phone', field: 'userContactPhone', filter: 'agTextColumnFilter', sortable: true, width: 130, resizable: true},
    /*
    {
      headerName: 'User Creation Date',
      field: 'userCreationDate',
      filter: 'agTextColumnFilter',
      sortable: true,
      resizable: true,
      valueGetter: function (params) {
        return moment(params.data.userCreationDate).format('MM/DD/YYYY');
      }
    },
    */
    {headerName: 'Total # Shipments', field: 'totalShipments', filter: 'agTextColumnFilter', sortable: true, resizable: true},
    {headerName: 'Total Spend Amt', field: 'totalSpendAmt', filter: 'agTextColumnFilter', sortable: true, width: 150, resizable: true}
  ];
  excelStyles = [
    {
      id: 'textFormat',
      dataType: 'string',
    }
  ];

  constructor(private reportsService: ReportsService,
              private alertService: AlertService,
              private loadingService: LoadingService,
              private cdref: ChangeDetectorRef,
              private fb: UntypedFormBuilder
  ) {
    this.paginationPageSize = 25;
  }

  ngOnInit() {
    this.generateFormGroupController();
    this.onSearch();
  }

  generateFormGroupController() {
    this.filterGroup = this.fb.group({
      fromDate: new UntypedFormControl(''),
      toDate: new UntypedFormControl('')
    });
  }

  seatchByFilter() {
    this.onSearch();
    const params = {
      force: true
    };
    this.gridApi.refreshCells(params);
  }

  onGridReady(params) {
    this.gridApi = params.api;
  }

  onSearch() {
    this.hhgListDetails = [];
    this.errorMessage = '';
    this.loadingService.show();
    const beginDate = new Date(this.filterGroup.get('fromDate').value).getTime();
    const endDate = new Date(this.filterGroup.get('toDate').value).getTime();
    this.reportsService.getHHGDetails(this.order, this.reverse, beginDate ? beginDate : this.hhg_filter.beginDate, endDate ? endDate : this.hhg_filter.endDate)
      .subscribe(data => {
          this.hhgListDetails = data;
        }, (error) => {
          this.errorMessage = error;
          this.alertService.error('No records found for the search criteria ');
          this.loadingService.hide();
        }, () => {
          // console.log('Successfully retrieved frt list details: ', this.hhgListDetails);
          this.loadingService.hide();
        }
      );
  }

  dateConverter(date: any) {
    return moment(date).format('MM/DD/YYYY');
  }

  setupPayload() {
    this.hhg_filter.beginDate = (!_.isDate(this.filterGroup.get('fromDate').value)) ?
      0 : Date.parse(this.filterGroup.get('fromDate').value);
    this.hhg_filter.endDate = (!_.isDate(this.filterGroup.get('toDate').value)) ?
      Date.now() : Date.parse(this.filterGroup.get('toDate').value);
  }

  resetFilter() {
    this.hhg_filter.beginDate = null;
    this.hhg_filter.endDate = null;
  }

  filterFromDateChange(formDate: any) {
    if (formDate === '' || formDate === null) {
    } else {
      if (!_.isDate(this.filterGroup.get('toDate').value)) {
        if (Date.parse(formDate) < Date.now()) {
          console.log('must be less than current date');
        }
      } else {
        if (formDate > this.filterGroup.get('toDate').value) {
          console.log('must be smaller');
        }
      }
    }
    this.filterGroup.get('fromDate').updateValueAndValidity();
  }

  filterToDateChange(toDate: any) {
    if (toDate === '' || toDate === null) {
    } else {
      if (!_.isDate(this.filterGroup.get('toDate').value)) {

      } else {
        if (!_.isDate(this.filterGroup.get('fromdate').value)) {
        } else {
          if (toDate > this.filterGroup.get('fromdate').value) {
            console.log('must be smaller');
          }
        }
      }
    }
    this.filterGroup.get('toDate').updateValueAndValidity();
  }

  turnOnvalidationFromDate() {
    this.filterGroup.get('fromdate').setValidators([Validators.required]);
  }

  turnOnvalidationToDate() {
    this.filterGroup.get('toDate').setValidators([Validators.required]);
  }

}
